import { css } from 'styled-components'
import mediaQuery from './mediaQuery'
import colors from './colors'

export const containerDefaultStyles = css`
  display: block;
  width: 1230px;
  max-width: 100%;
  padding: 0 15px;
  margin-left: auto;
  margin-right: auto;
`

export const formComponentDefaultStyles = css`
  border: 1px solid ${colors.gray3};
  padding: 10px 16px;
  background-color: ${colors.white};
  line-height: 24px;
  width: 100%;
  border-radius: 7px;
  font-size: 16px;
  box-shadow: none;
  -webkit-appearance: none;
  ${mediaQuery.mobile} {
    font-size: 16px;
  }
  &:focus {
    border-color: ${colors.greenMain};
    outline-color: ${colors.greenMain};
  }
  &[disabled],
  &:disabled {
    background-color: ${colors.grayLight};
    color: ${colors.gray};
  }
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${colors.placeholderColor};
    font-weight: 300;
  }
`
